import {
  FORM_ITEM__SINGLE_LINE,
  FORM_ITEM__NUMBER,
  FORM_ITEM__CURRENCY,
  FORM_ITEM__DATE,
  FORM_ITEM__DATE_RANGE,
  FORM_ITEM__DROPDOWN,
  FORM_ITEM__YES_NO,
  FORM_ITEM__EXTERNAL_DATA_SOURCE,
  FORM_ITEM__MEMBER,
  FORM_ITEM__DEPARTMENT,
  FORM_ITEM__ADDRESS,
  FORM_ITEM__ATTACHMENT,
  FORM_ITEM__CHECKBOX,
  FORM_ITEM__GRADE,
  FORM_ITEM__IMAGE,
  FORM_ITEM__SINGLE_CHOOSE,
  FORM_ITEM__OUT_REQUEST,
  FORM_ITEM__SIGNATURE,
  FORM_ITEM__BUTTON,
  FORM_ITEM__REALTIME_DATA,
  FORM_ITEM__MULTILINE,
  FORM_ITEM__CASCADE
} from '../../types'

import SingleLine from './TableSingleLine'
import Digital from './TableDigital'
import Currency from './TableCurrency'
import DateInput from './TableDateInput'
import DateRange from './TableDateRange'
import Dropdown from './TableDropdown'
import YesNo from "./TableYesNo"
import ExternalDataSource from "./TableExternalDataSource"
import Member from "./TableMember"
import Department from "./TableDepartment"
import Address from "./TableAddress"
import Attachment from "./TableAttachment"
import Checkbox from "./TableCheckbox"
import Grade from "./TableGrade"
import ImageAttachment from "./TableImageAttachment"
import SingleChoose from "./TableSingleChoose"
import OutRequest from "./TableOutRequest"
import Signature from "./Signature"
import Button from "./Button";
import RealTimeData from "./RealTimeData"
import Multiline from "./TableMultiline"
import Cascade from "./TableCascade"

export default {
  ['table_' + FORM_ITEM__SINGLE_LINE]: SingleLine,
  ['table_' + FORM_ITEM__MULTILINE]: Multiline,
  ['table_' + FORM_ITEM__NUMBER]: Digital,
  ['table_' + FORM_ITEM__CURRENCY]: Currency,
  ['table_' + FORM_ITEM__DATE]: DateInput,
  ['table_' + FORM_ITEM__DATE_RANGE]: DateRange,
  ['table_' + FORM_ITEM__DROPDOWN]: Dropdown,
  ['table_' + FORM_ITEM__YES_NO]: YesNo,
  ['table_' + FORM_ITEM__EXTERNAL_DATA_SOURCE]: ExternalDataSource,
  ['table_' + FORM_ITEM__MEMBER]: Member,
  ['table_' + FORM_ITEM__DEPARTMENT]: Department,
  ['table_' + FORM_ITEM__ADDRESS]: Address,
  ['table_' + FORM_ITEM__ATTACHMENT]: Attachment,
  ['table_' + FORM_ITEM__CHECKBOX]: Checkbox,
  ['table_' + FORM_ITEM__GRADE]: Grade,
  ['table_' + FORM_ITEM__IMAGE]: ImageAttachment,
  ['table_' + FORM_ITEM__SINGLE_CHOOSE]: SingleChoose,
  ['table_' + FORM_ITEM__OUT_REQUEST]: OutRequest,
  ['table_' + FORM_ITEM__SIGNATURE]: Signature,
  ['table_' + FORM_ITEM__BUTTON]: Button,
  ['table_' + FORM_ITEM__REALTIME_DATA]: RealTimeData,
  ['table_' + FORM_ITEM__CASCADE]: Cascade
}
